export default "__VITE_ASSET__C7LnbMpw__"